import React from 'react';

const LOGO_HORIZONTAL = 'https://customer-assets.emergentagent.com/job_pest-tracker-app/artifacts/jmgtmiz2_LOGO%20CHICO.pdf.jpg';
const LOGO_SEAL = 'https://customer-assets.emergentagent.com/job_pest-tracker-app/artifacts/pzaza9gx_seal_xprtpsts.png';

export default function XpertLogo({ size = 40, light = false, variant = 'mark', className = '' }) {
  // Variants: 'mark' (small square crop for icons/sidebar), 'seal' (full oval)
  const src = variant === 'seal' ? LOGO_SEAL : LOGO_HORIZONTAL;
  const style = variant === 'mark'
    ? { width: size, height: size, objectFit: 'cover', objectPosition: '8% 50%' }
    : { width: size, height: size, objectFit: 'contain' };
  return (
    <div
      className={`rounded-lg overflow-hidden flex-shrink-0 ${light ? 'bg-white/95' : 'bg-white'} ${className}`}
      style={{ width: size, height: size, padding: variant === 'mark' ? 2 : 0 }}
    >
      <img src={src} alt="Xpertpests Solutions" style={style} draggable={false}/>
    </div>
  );
}

export function XpertWordmark({ light = false, size = 'md' }) {
  const text = light ? 'text-white' : 'text-slate-900';
  const sub = light ? 'text-white/70' : 'text-slate-500';
  const sizes = {
    sm: { title: 'text-base', sub: 'text-[8px]' },
    md: { title: 'text-[20px]', sub: 'text-[9px]' },
    lg: { title: 'text-2xl', sub: 'text-[10px]' },
  }[size];
  return (
    <div className="leading-tight">
      <div className={`${sizes.title} font-extrabold tracking-tight ${text}`}>
        <span className="text-[#8BC53F]">X</span>pertpests <span className="font-light">Solutions</span>
      </div>
      <div className={`${sizes.sub} font-semibold tracking-[0.18em] ${sub} -mt-1`}>REAL RESULTS, FORGET THE REST!</div>
    </div>
  );
}

export const BRAND_LOGO_HORIZONTAL = LOGO_HORIZONTAL;
export const BRAND_LOGO_SEAL = LOGO_SEAL;
